"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Favorites = void 0;
var react_1 = __importDefault(require("react"));
var Favorites_module_scss_1 = __importDefault(require("./Favorites.module.scss"));
var CardAuto_1 = require("../../components/cardAuto/CardAuto");
var getValueFromLocalStorage_1 = require("../../helpers/localStorage/getValueFromLocalStorage");
var BreadCrumpPage_1 = require("../../components/breadCrumpPage/BreadCrumpPage");
var Favorites = function () {
    var carList = (0, getValueFromLocalStorage_1.getValueFromLocalStorage)('favorites', []);
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement("div", { className: "page" },
            react_1.default.createElement(BreadCrumpPage_1.BreadCrumpPage, { links: [
                    { name: 'Главная', url: '/' },
                    { name: 'Избранное', url: '/favorites' },
                ] }),
            react_1.default.createElement("h1", { className: 'page__title' }, "\u0418\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435"),
            react_1.default.createElement("div", { className: Favorites_module_scss_1.default.favorites__list }, carList.length
                ? carList.map(function (car) {
                    return react_1.default.createElement(CardAuto_1.CardAuto, __assign({}, car));
                })
                : 'Нет избранных авто'))));
};
exports.Favorites = Favorites;
